import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import b2bService from '../../services/b2bService';
import './B2bPortalLoginPage.css';

const B2bPortalLoginPage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      setError('Please provide your client username and password.');
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const data = await b2bService.portalLogin(username, password);
      if (data && data.token) {
        // Store in sessionStorage to guarantee Zero-Trust Tenant isolation from internal staff credentials
        sessionStorage.setItem('b2b_portal_token', data.token);
        sessionStorage.setItem(
          'b2b_portal_user',
          JSON.stringify({
            userId: data.userId,
            partyId: data.partyId,
            partyCode: data.partyCode,
            partyName: data.partyName,
            fullName: data.fullName,
            role: data.role,
            creditLimit: data.creditLimit
          })
        );

        navigate('/b2b/portal/dashboard');
      } else {
        setError('Authentication response did not contain a valid session token.');
      }
    } catch (err) {
      const msg = err.response?.data?.message || err.message || 'Login failed. Please check credentials.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="b2b-login-container">
      <div className="b2b-login-card">
        <div className="b2b-login-header">
          <span className="b2b-login-badge">Institutional Access</span>
          <h1 className="b2b-login-title">Client Partner Portal</h1>
          <p className="b2b-login-subtitle">Sign in to review batch orders, download reports &amp; manage corporate statements.</p>
        </div>

        {error && <div className="b2b-login-alert">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="b2b-form-group">
            <label className="b2b-form-label" htmlFor="b2b-username">Client Username</label>
            <input
              id="b2b-username"
              type="text"
              className="b2b-form-input"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="e.g. apex_clinic_admin"
              required
              autoFocus
            />
          </div>

          <div className="b2b-form-group">
            <label className="b2b-form-label" htmlFor="b2b-password">Password</label>
            <input
              id="b2b-password"
              type="password"
              className="b2b-form-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••••••"
              required
            />
          </div>

          <button type="submit" className="b2b-submit-btn" disabled={loading}>
            {loading ? 'Authenticating...' : 'Sign In to Portal'}
          </button>
        </form>

        <div className="b2b-login-footer">
          <div>Diagnostic Center Staff Member?</div>
          <Link to="/login" className="b2b-back-link">
            &larr; Switch to Laboratory Internal Login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default B2bPortalLoginPage;
